import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'funds_risk') {
    return;
  }

  const $fundsRisk = $('#fundsRisk input[type=radio]', $form);

  $fundsRisk.on('click', (inputElement) => {
    $form.submit();
  });
})
